import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { Box, Paper, Typography, CircularProgress, Alert, Button } from '@mui/material';
import { api } from '../lib/api';
import { useAuth } from '../hooks/useAuth';

export default function MagicCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [status, setStatus] = useState<'verifying' | 'error' | 'ok'>('verifying');
  const [message, setMessage] = useState('Verifying your link…');

  useEffect(() => {
    const token = params.get('token');
    if (!token) {
      setStatus('error');
      setMessage('No token in the link.');
      return;
    }
    (async () => {
      try {
        await api.post('/api/auth/verify', { token });
        await refresh();
        setStatus('ok');
        navigate('/', { replace: true });
      } catch (err) {
        setStatus('error');
        setMessage((err as Error).message);
      }
    })();
  }, [params, navigate, refresh]);

  return (
    <Box sx={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      bgcolor: 'background.default',
      px: 2,
    }}>
      <Paper sx={{ p: 4, maxWidth: 420, width: '100%', textAlign: 'center' }} elevation={0} variant="outlined">
        {status === 'verifying' && (
          <>
            <CircularProgress sx={{ mb: 2 }} />
            <Typography>{message}</Typography>
          </>
        )}
        {status === 'ok' && <Alert severity="success">Signed in.</Alert>}
        {status === 'error' && (
          <>
            <Alert severity="error" sx={{ mb: 2 }}>{message}</Alert>
            <Button onClick={() => navigate('/login')}>Back to sign in</Button>
          </>
        )}
      </Paper>
    </Box>
  );
}
